import * as React from "react";
import { TrafficGraphWithDaySelect } from "components/common/Graph";
import useGraphDays from "components/common/Graph/contexts/useGraphDays";
import useClusterTraffic from "./hooks/useClusterTraffic";
const ClusterTrafficGraph = () => {
  const { graphDays } = useGraphDays();
  const { traffic } = useClusterTraffic(graphDays);
  return /* @__PURE__ */ React.createElement(TrafficGraphWithDaySelect, { traffic: traffic == null ? void 0 : traffic.input_indexed, trafficType: "input-indexed" });
};
export default ClusterTrafficGraph;
